import { render, staticRenderFns } from "./languageSearch.vue?vue&type=template&id=7496377b&scoped=true&"
import script from "./languageSearch.vue?vue&type=script&lang=js&"
export * from "./languageSearch.vue?vue&type=script&lang=js&"
import style0 from "./languageSearch.vue?vue&type=style&index=0&id=7496377b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7496377b",
  null
  
)

export default component.exports